export { default } from './AdvantagesSection';
export type { default as ItemProps } from './components/AdvantageItem/AdvantageItem.types';
